import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useNavigate } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import Breadcrumbs from "../../components/Breadcrumbs";
import EditForm from "../../components/EditForm";
import { useAuth } from "../../providers/AuthContext";
import { createHistoryAndBilling } from "../../api/BillingGroups";
import toast from "react-hot-toast";

const CreateHistoryBillingPage = () => {
  const navigate = useNavigate();
  const { getAccessToken } = useAuth();
  const { agreementPublicId } = useAuth();

  const [billingHistory, setBillingHistory] = useState({
    year: "",
    month: "",
    subject: "",
  });

  const [hasChanges, setHasChanges] = useState(false);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleCreateBillingHistory = async () => {
    try {
      const { year, month, subject } = billingHistory;
  
      const body = {
        agreementPublicId,
        year: parseInt(year),
        month: parseInt(month),
        subject: subject.trim(),
      };
  
      await createHistoryAndBilling(body);

      window.dispatchEvent(new Event("historyBillingCreated"));
  
      toast.success("History and billing created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });
  
      navigate(-1);
    } catch (error) {
      console.error("Failed to create:", error);
      toast.error("Failed to create history and billing");
    }
  };

  const months = [
    { label: "January (01)", value: "01" },
    { label: "February (02)", value: "02" },
    { label: "March (03)", value: "03" },
    { label: "April (04)", value: "04" },
    { label: "May (05)", value: "05" },
    { label: "June (06)", value: "06" },
    { label: "July (07)", value: "07" },
    { label: "August (08)", value: "08" },
    { label: "September (09)", value: "09" },
    { label: "October (10)", value: "10" },
    { label: "November (11)", value: "11" },
    { label: "December (12)", value: "12" },
  ];

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={handleBackClick} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create history and billing</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={handleBackClick}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!hasChanges}
                  onClick= {handleCreateBillingHistory}
                >
                  Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
              <EditForm
                data={billingHistory}
                setData={setBillingHistory}
                setHasChanges={setHasChanges}
                disabled={false}
                fields={[
                  { key: "year", label: "Year", type: "number" },
                  { key: "month", label: "Month", type: "dropdown", text: "Select month", options: months },
                  { key: "subject", label: "Subject", type: "text" },
                  { key: "three/one", label: "3 months", type: "switch" },
                ]}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateHistoryBillingPage;
